module.exports = __webpack_public_path__ + "img/horizontal_6_6_7042.9ae23cb3.png";